import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


import 'bootstrap/dist/css/bootstrap.css';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';
import './index.css';
import './fonts/fonts.css';

ReactDOM.render(<App />, document.getElementById('root'));
